import Link from "shared/components/navigation/links/AnchorLink";
import PropTypes from "prop-types";
import React from "react";

const SaveHoursErrorSnack = ({ projectName, onTryAgain }) => {
    return (
        <>
            <span>
                Changes to <b>{projectName}</b> have not been save.
            </span>
            <Link
                variant="secondary"
                color={globalThis.config.colors.white}
                href={void 0}
                onClick={onTryAgain}
            >
                Try again
            </Link>
        </>
    );
};

SaveHoursErrorSnack.propTypes = {
    projectName: PropTypes.string.isRequired,
    onTryAgain: PropTypes.func.isRequired,
};

export default SaveHoursErrorSnack;
